import { useCallback, useEffect, useState } from 'react';

import { RESET_STORAGE_KEY } from '@/configs/local-storage-keys';
import { clearSentryUser, setSentryUser } from '@/shared/lib/sentry';
import { toast } from '@/stores/pure/ToastStore';
import useUserStore from '@/stores/UserStore';
import cookieUtil from '@/utils/cookie';

// 로컬스토리지 전체 초기화를 위한 reset value
// 필드 추가 및 삭제 등 모델 변경 시 초기화 필요
const RESET_VALUE = '260402';

const COOKIE_RESET_VALUE = '251205';

const useAuthInit = () => {
  const { checkUser, user } = useUserStore((state) => ({
    checkUser: state.checkUser,
    user: state.user,
  }));
  const [userID, setUserID] = useState<undefined | string>(undefined);
  const [loading, setLoading] = useState(false);

  const initAuthCheck = useCallback(async () => {
    const cookieResetValue = localStorage.getItem('COOKIE_RESET_VALUE');
    if (cookieResetValue !== COOKIE_RESET_VALUE) {
      cookieUtil.deleteAllCookies();
      localStorage.setItem('COOKIE_RESET_VALUE', COOKIE_RESET_VALUE);
    }
    if (loading || user?.user_id === userID) return;
    setLoading(true);
    setUserID(user?.user_id);
    await checkUser();

    const prevResetValue = localStorage.getItem(RESET_STORAGE_KEY);
    if (prevResetValue !== RESET_VALUE) {
      localStorage.clear();
      localStorage.setItem(RESET_STORAGE_KEY, RESET_VALUE);
      toast('Local storage has been reset.', 'success');
    }

    setLoading(false);
  }, [checkUser, loading, user?.user_id, userID]);

  useEffect(() => {
    initAuthCheck();
  }, [initAuthCheck]);

  // Sentry 사용자 설정
  useEffect(() => {
    if (user) {
      setSentryUser(user);
    } else {
      clearSentryUser();
    }
  }, [user]);
};

export default useAuthInit;
